import React from 'react';
import PropTypes from 'prop-types';
import {browserHistory, Link} from 'react-router';
import connectToStores from 'alt-utils/lib/connectToStores';
import Team from 'records/Team';
import moment from 'moment';
import DashboardBreadcrumbs from './DashboardBreadcrumbs';
import buildUrl from 'components/dashboard/buildUrl';
import DirectReportsStore from 'stores/coaching/DirectReportsStore';
import DirectReportsActions from 'actions/coaching/DirectReportsActions';
import './DashboardHeader.styl';
import {UserSelector} from 'components/pure/utils/form/UserSelector';
import AuthStore from 'stores/AuthStore';
import {List} from 'immutable';
import {getCoachRepLink} from 'components/dashboard/coach/CoachSummaryDashboard';
import DashboardDeptFilter from 'components/dashboard/DashboardDeptFilter';
import DashboardDateRangePicker from 'components/dashboard/date-range-picker/DashboardDateRangePicker';
import Button from '@material-ui/core/Button';
import {HISTORY_ACTIONS} from 'components/StatsPage2.utils';
import TopicRollupDateRangeSelect from 'components/dashboard/date-range-picker/TopicRollupDateRangeSelect';
import {getQueryParam} from 'utils/getQueryParam';
import {associateBy} from 'utils/associateBy';

@connectToStores
export default class DashboardHeader extends React.PureComponent {
  static getStores() {
    return [DirectReportsStore, AuthStore];
  }

  static getPropsFromStores(props) {
    const teams = DirectReportsStore.getState().teams;
    return {
      teams: props.adminId && !props.managerId ? teams : List(),
      users: associateBy(
        teams.flatMap(t => t.users),
        u => u.id
      ),
      sessionUser: AuthStore.getState().user,
    };
  }

  componentDidMount() {
    const {adminId, managerId} = this.props;
    if (adminId && !managerId) {
      // If this is the admin dash (not a manager dash viewed through an admin),
      // we want to check if this admin has any teams
      DirectReportsActions.directReports(adminId);
    }
  }

  componentDidUpdate(prevProps) {
    const {adminId, managerId} = this.props;
    const {managerId: prevManagerId} = prevProps;
    // If this is the admin dash we want to check if this admin has any teams, but only
    // when we become the admin dash (from a manager dash viewed through an admin)
    if (adminId && !managerId && prevManagerId) {
      DirectReportsActions.directReports(adminId);
    }
  }

  onRepSelect = repId => {
    const rep = this.props.users.get(repId);
    if (!rep) return;
    // In this component the endDate is inclusive
    const link = getCoachRepLink({rep}, this.props, {}, true, null);
    browserHistory.push(link);
  };

  renderViewManagerLink() {
    const {adminId, fromPath} = this.props;
    const pathname = buildUrl({adminId, managerId: adminId});
    const state = {
      pathname: fromPath,
      action: HISTORY_ACTIONS.PUSH,
    };
    return (
      <div className="view-manager-dash">
        <Button
          variant="outlined"
          component={Link}
          to={{pathname, state}}
          className="generic-link view-man-link">
          View My Team Dashboard
        </Button>
      </div>
    );
  }

  render() {
    const {
      selectedTeam,
      startDate,
      endDate,
      coachId,
      managerId,
      adminId,
      teams,
      users,
      sessionUser,
      topicRollupDateRanges,
      isTopicRollup,
      location,
      fromPath,
      onSummary,
    } = this.props;

    const showMyTeamLink = adminId && !managerId && teams && !teams.isEmpty();
    const isOnCoachingPlansSubPage =
      fromPath && fromPath.indexOf('/coaching-plans') >= 0 && getQueryParam(location, 'planId');
    const showRepSearch = managerId && onSummary;

    return (
      <div className="dashboard-header">
        <div className="flex-wrapper">
          <DashboardBreadcrumbs
            repId={this.props.repId}
            rep={this.props.rep}
            coachId={coachId}
            managerId={managerId}
            adminId={adminId}
            selectedTeam={selectedTeam}
            onSelectTeam={this.props.onSelectTeam}
            onSelectRep={this.props.onSelectRep}
            isOnCoachingPlansSubPage={isOnCoachingPlansSubPage}
          />
          {!managerId && <DashboardDeptFilter />}
        </div>
        {showRepSearch && (
          <UserSelector
            placeholder="Search for Reps"
            users={users}
            sessionUser={sessionUser}
            onChange={this.onRepSelect}
          />
        )}
        {showMyTeamLink && this.renderViewManagerLink()}
        {isTopicRollup ? (
          <TopicRollupDateRangeSelect
            startDate={startDate}
            endDate={endDate}
            topicRollupDateRanges={topicRollupDateRanges}
          />
        ) : (
          <DashboardDateRangePicker startDate={startDate} endDate={endDate} location={location} />
        )}
      </div>
    );
  }
}

DashboardHeader.propTypes = {
  selectedTeam: PropTypes.instanceOf(Team),
  startDate: PropTypes.instanceOf(moment).isRequired,
  endDate: PropTypes.instanceOf(moment).isRequired,
  onSelectTeam: PropTypes.func.isRequired, // (Team) => void
};
